"use client";

import Image from "next/image";
import Link from "next/link";
import { FiInstagram } from "react-icons/fi";

import { INSTAGRAM_LINK } from "@/constants/links";
import { logEvent } from "@/services/firebase";
import { ScheduledAppointment } from "./ui";

export const Hero = () => {
  return (
    <section className="pt-28 md:pt-36 lg:pt-40 pb-8 md:pb-12 lg:pb-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col lg:flex-row items-center gap-8">
        <div className="w-full lg:w-1/2 text-center lg:text-left">
          <h1 className="text-3xl lg:text-5xl font-bold text-secondary">
            Nutricionista <br /> Domynique Mota
          </h1>
          <p className="text-paragraph text-lg leading-relaxed my-10">
            Maximize sua performance com uma nutricionista esportiva
            especializada! Planos personalizados, suporte real e estratégias
            eficazes para{" "}
            <strong>atingir seus objetivos comendo o que gosta</strong>.
          </p>
          <ScheduledAppointment section="hero" />
        </div>

        <div className="relative w-full lg:w-1/2 p-6 lg:p-12 flex justify-center flex-col items-center">
          <div className="rounded-full  flex items-center justify-center">
            <Image
              src="/images/illustration.png"
              alt="Domynique Mota"
              width={350}
              height={350}
              className="rounded-full object-cover w-48 sm:w-64 h-48 sm:h-64 mr-6"
              priority
            />
          </div>
          <div>
            <Link
              href={INSTAGRAM_LINK}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visitar perfil no Instagram de Domynique Mota"
              className="flex items-center justify-center w-12 h-12 bg-primary rounded-full shadow hover:opacity-90 transition"
              onClick={() => logEvent("instagram_click", { section: "hero" })}
            >
              <FiInstagram
                size={24}
                className="text-white"
                aria-hidden="true"
              />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};
